import React, { useState } from 'react';
import { TelegramIcon, XIcon, MailIcon } from './icons';
import { TG_URL, X_URL, EMAIL, CONTRACT } from '../data';
import Privacy from './Privacy';
import CookieBanner from './CookieBanner';
import logo from '../../public/smartpepe.webp';
import '../styles/footer.css';

const LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Tokenomics', href: '#tokenomics' },
  { label: 'How to buy', href: '#how-to-buy' },
  { label: 'Redeem', href: '#redeem' },
  { label: 'Partners', href: '#partners' },
];

const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <footer className="footer">
      <div className="separator-glow" />
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo-row">
            <img src={logo} alt="" className="footer-logo" />
            <span className="footer-wordmark">$KEK</span>
          </div>
          <p className="footer-tag">community meme token experience on WAX.</p>
          <p className="footer-ca">entertainment only — not an investment product</p>
        </div>

        <nav className="footer-links" aria-label="Footer">
          {LINKS.map((l) => <a key={l.href} href={l.href}>{l.label}</a>)}
        </nav>

        <div className="footer-socials">
          <a href={TG_URL} target="_blank" rel="noopener noreferrer" aria-label="Telegram"><TelegramIcon /></a>
          <a href={X_URL} target="_blank" rel="noopener noreferrer" aria-label="X / Twitter"><XIcon /></a>
          <a href={`mailto:${EMAIL}`} aria-label="Email"><MailIcon /></a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} made with 🐸 &amp; ☕️ by kek. all rights reserved.</p>
        <button type="button" onClick={() => setShowPrivacy(true)}>Privacy Policy</button>
      </div>

      {showPrivacy && <Privacy onDismiss={() => setShowPrivacy(false)} />}
      <CookieBanner />
    </footer>
  );
};

export default Footer;
